/** Default WhatsApp texts for the pre-registration review (the admin edits them before sending) */

export type ReviewMessageStatus = 'PRE_REGISTERED' | 'VERIFIED' | 'REJECTED';

interface ReviewMessageInput {
  status: ReviewMessageStatus;
  fullName: string;
  eventName: string;
  /** /p/<token> page with the filled form */
  formUrl: string;
  rejectionReason?: string | null;
  /** Personal edit link (ADB-169) so the person can correct the registration themselves */
  editLink?: { url: string; expiresAt: string } | null;
  now?: Date;
}

/** "7 días (hasta el 05/11/2026)" */
function validity(expiresAt: string, now: Date): string {
  const days = Math.max(1, Math.round((new Date(expiresAt).getTime() - now.getTime()) / 86_400_000));
  return `${days} ${days === 1 ? 'día' : 'días'}, hasta el ${new Date(expiresAt).toLocaleDateString('es-BO')}`;
}

export function reviewMessage({ status, fullName, eventName, formUrl, rejectionReason, editLink, now = new Date() }: ReviewMessageInput): string {
  const first = fullName.trim().split(/\s+/)[0] || 'hermano(a)';
  const event = eventName || 'el evento';

  if (status === 'VERIFIED') {
    return `Hola ${first}, su inscripción a ${event} fue verificada. Puede ver su formulario aquí: ${formUrl}`;
  }
  if (status === 'REJECTED') {
    const reason = rejectionReason?.trim() ? ` Motivo: ${rejectionReason.trim()}.` : '';
    if (editLink) {
      return (
        `Hola ${first}, su inscripción a ${event} fue observada.${reason} ` +
        `Puede corregirla desde su teléfono con este enlace personal (vigente ${validity(editLink.expiresAt, now)}): ${editLink.url} ` +
        `No lo comparta: quien tenga el enlace puede editar su inscripción. Si necesita ayuda, responda a este mensaje.`
      );
    }
    return `Hola ${first}, su inscripción a ${event} fue observada.${reason} Puede ver su inscripción aquí: ${formUrl}. Responda a este mensaje y le ayudaremos a corregirla.`;
  }
  // Pending: the admin writes the observation
  return `Hola ${first}, revisamos su preinscripción a ${event} y encontramos lo siguiente: [escriba aquí la observación]. Responda a este mensaje para completarla.`;
}
